import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import XLSX from "xlsx-js-style";

export const useInputBon = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [popUpNewItem, setPopUpNewItem] = useState(false);
  const [checkBoxNama, setCheckBoxNama] = useState("");
  const [selectNama, setSelectNama] = useState();
  const [namaBonInput, setNamaBonInput] = useState("");
  const [nominal, setNominal] = useState();
  const [keterangan, setKeterangan] = useState();
  const [isDisabled, setIsDisabled] = useState(false);

  const [isRefresh, setIsRefresh] = useState(false);
  const [isErr, setIsErr] = useState(false);

  const [listNamaBon, setListNamaBon] = useState();
  const [listBon, setListBon] = useState();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getNamaBonSupir`,
      {
        tim: dataUser.tim,
        creator: dataUser.name,
        keterangan: keterangan,
        name: checkBoxNama === "ada" ? selectNama : namaBonInput,
        type: checkBoxNama,
        nominal: nominal,
      },
      dataUser.auth,
      setListNamaBon,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListBonSupir`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setListBon,
      ""
    );
  }, [isRefresh]);

  const handleKirimInputBon = () => {
    if (
      ((checkBoxNama === "ada" && selectNama) ||
        (checkBoxNama === "belum" && namaBonInput)) &&
      nominal
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/InputBon`,
        {
          tim: dataUser.tim,
          creator: dataUser.name,
          keterangan: keterangan,
          name: checkBoxNama === "ada" ? selectNama : namaBonInput,
          type: checkBoxNama,
          nominal: nominal,
        },
        dataUser.auth,
        "",
        ""
      );
      setTimeout(() => {
        setIsErr(false);
        setIsDisabled(false);
        setNominal();
        setKeterangan();
        setNamaBonInput();
        setPopUpNewItem();
        setSelectNama();
        setIsRefresh(true);
        setCheckBoxNama("");
      }, 500);
    } else {
      setIsErr(true);
      setIsDisabled(false);
    }
  };

  return {
    dataUser,
    popUpNewItem,
    setPopUpNewItem,
    checkBoxNama,
    setCheckBoxNama,
    nominal,
    setNominal,
    isDisabled,
    setIsDisabled,
    keterangan,
    setKeterangan,
    namaBonInput,
    setNamaBonInput,
    handleKirimInputBon,
    isErr,
    setIsErr,
    selectNama,
    setSelectNama,
    listNamaBon,
    listBon,
  };
};
